import { apiClient } from './client'
import type { ApiResponse } from './client'
import type {
  SuppressionListDto,
  SuppressionEntryDto,
  SuppressionListQuery,
  SuppressionCreatePayload,
  SuppressionImportPayload,
  SuppressionImportResultDto,
} from '@/types/suppressions'

const base = (clientCompanyId: string) => `/api/ClientCompanies/${clientCompanyId}/Suppressions`

export const suppressionsApi = {
  // One page of the company's suppression list. Optional address search + active filter.
  list: (clientCompanyId: string, query: SuppressionListQuery = {}): Promise<ApiResponse<SuppressionListDto>> => {
    const params = new URLSearchParams()
    if (query.search) params.set('search', query.search)
    if (query.active !== undefined) params.set('active', String(query.active))
    if (query.skip !== undefined) params.set('skip', String(query.skip))
    if (query.take !== undefined) params.set('take', String(query.take))
    const qs = params.toString()
    return apiClient.get(`${base(clientCompanyId)}${qs ? `?${qs}` : ''}`)
  },

  // Manually add one address (Admin Action source, sticky). 422 on a blank/invalid address.
  add: (clientCompanyId: string, payload: SuppressionCreatePayload): Promise<ApiResponse<SuppressionEntryDto>> =>
    apiClient.post(base(clientCompanyId), payload),

  // Remove (re-subscribe) an address — admin override that clears even sticky entries. Idempotent 204.
  remove: (clientCompanyId: string, email: string): Promise<ApiResponse<void>> =>
    apiClient.delete(`${base(clientCompanyId)}?email=${encodeURIComponent(email)}`),

  // Bulk-import a customer-supplied opt-out list (Import source, sticky). Returns an outcome tally.
  import: (clientCompanyId: string, payload: SuppressionImportPayload): Promise<ApiResponse<SuppressionImportResultDto>> =>
    apiClient.post(`${base(clientCompanyId)}/Import`, payload),
}
